import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { toDisposable } from '../../../base/common/lifecycle.js';
import { validateConstraints } from '../../../base/common/types.js';
import { createDecorator } from '../../instantiation/common/instantiation.js';
import { Emitter } from '../../../base/common/event.js';
import { LinkedList } from '../../../base/common/linkedList.js';
import { Iterable } from '../../../base/common/iterator.js';
export var ICommandService = createDecorator('commandService');
export var CommandsRegistry = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this._commands = new Map();
    this._onDidRegisterCommand = new Emitter();
    this.onDidRegisterCommand = this._onDidRegisterCommand.event;
  }

  _createClass(_class, [{
    key: "registerCommand",
    value: function registerCommand(idOrCommand, handler) {
      var _this = this;

      if (!idOrCommand) {
        throw new Error("invalid command");
      }

      if (typeof idOrCommand === 'string') {
        if (!handler) {
          throw new Error("invalid command");
        }

        return this.registerCommand({
          id: idOrCommand,
          handler: handler
        });
      } // add argument validation if rich command metadata is provided


      if (idOrCommand.description) {
        var constraints = [];

        var _iterator = _createForOfIteratorHelper(idOrCommand.description.args),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var arg = _step.value;
            constraints.push(arg.constraint);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var actualHandler = idOrCommand.handler;

        idOrCommand.handler = function (accessor) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          validateConstraints(args, constraints);
          return actualHandler.apply(void 0, [accessor].concat(args));
        };
      } // find a place to store the command


      var id = idOrCommand.id;

      var commands = this._commands.get(id);

      if (!commands) {
        commands = new LinkedList();

        this._commands.set(id, commands);
      }

      var removeFn = commands.unshift(idOrCommand);
      var ret = toDisposable(function () {
        removeFn();

        var command = _this._commands.get(id);

        if (command === null || command === void 0 ? void 0 : command.isEmpty()) {
          _this._commands.delete(id);
        }
      }); // tell the world about this command

      this._onDidRegisterCommand.fire(id);

      return ret;
    }
  }, {
    key: "registerCommandAlias",
    value: function registerCommandAlias(oldId, newId) {
      return CommandsRegistry.registerCommand(oldId, function (accessor) {
        var _accessor$get;

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return (_accessor$get = accessor.get(ICommandService)).executeCommand.apply(_accessor$get, [newId].concat(args));
      });
    }
  }, {
    key: "getCommand",
    value: function getCommand(id) {
      var list = this._commands.get(id);

      if (!list || list.isEmpty()) {
        return undefined;
      }

      return Iterable.first(list);
    }
  }, {
    key: "getCommands",
    value: function getCommands() {
      var result = new Map();

      var _iterator2 = _createForOfIteratorHelper(this._commands.keys()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var command = this.getCommand(key);

          if (command) {
            result.set(key, command);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return result;
    }
  }]);

  return _class;
}())();